import React, { useState, useEffect } from 'react';
import './TestimonialsSection.css';

const TestimonialsSection = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Sarah Chen",
      position: "CTO, MedTech Solutions",
      company: "Healthcare",
      content: "Hyperion AI's computer vision solution revolutionized our diagnostic process. We've seen a 40% improvement in accuracy and 60% faster processing times. Their team understood our unique challenges and delivered beyond expectations.",
      rating: 5,
      image: "/images/testimonial-1.jpg"
    },
    {
      id: 2,
      name: "Michael Rodriguez",
      position: "VP of Operations, FinanceCore",
      company: "Financial Services",
      content: "The predictive analytics platform from Hyperion AI has transformed our risk assessment process. We've reduced fraud by 75% and improved customer satisfaction significantly. Outstanding technical expertise and support.",
      rating: 5,
      image: "/images/testimonial-2.jpg"
    },
    {
      id: 3,
      name: "Dr. Emily Watson",
      position: "Director of Innovation, ManufacturingPlus",
      company: "Manufacturing",
      content: "Their AI-powered quality control system has been a game-changer for our production line. We've eliminated 95% of defects and increased efficiency by 30%. The ROI was evident within the first quarter.",
      rating: 5,
      image: "/images/testimonial-3.jpg"
    },
    {
      id: 4,
      name: "James Thompson",
      position: "CEO, RetailTech Innovations",
      company: "Retail Technology",
      content: "Hyperion AI's generative AI chatbot has transformed our customer service. 24/7 intelligent support with 90% query resolution rate. Our customers love the instant, accurate responses.",
      rating: 5,
      image: "/images/testimonial-4.jpg"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const goToTestimonial = (index) => {
    setCurrentTestimonial(index);
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <span key={i} className={`star ${i < rating ? 'filled' : ''}`}>★</span>
    ));
  };

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <div className="testimonials-header">
          <h2 className="testimonials-title">What Our Clients Say</h2>
          <p className="testimonials-subtitle">
            Trusted by leading companies across industries to deliver transformative AI solutions
          </p>
        </div>

        <div className="testimonials-carousel">
          <div className="testimonial-card">
            <div className="testimonial-content">
              <div className="quote-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-10zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" fill="currentColor"/>
                </svg>
              </div>
              
              <p className="testimonial-text">
                "{testimonials[currentTestimonial].content}"
              </p>
              
              <div className="testimonial-rating">
                {renderStars(testimonials[currentTestimonial].rating)}
              </div>
            </div>

            <div className="testimonial-author">
              <div className="author-avatar">
                <div className="avatar-placeholder">
                  {testimonials[currentTestimonial].name.split(' ').map(n => n[0]).join('')}
                </div>
              </div>
              <div className="author-info">
                <h4 className="author-name">{testimonials[currentTestimonial].name}</h4>
                <p className="author-position">{testimonials[currentTestimonial].position}</p>
                <p className="author-company">{testimonials[currentTestimonial].company}</p>
              </div>
            </div>
          </div>

          <div className="testimonials-navigation">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`nav-dot ${index === currentTestimonial ? 'active' : ''}`}
                onClick={() => goToTestimonial(index)}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>

        <div className="client-logos">
          <div className="logos-container">
            <div className="logo-item">
              <div className="logo-placeholder">MedTech</div>
            </div>
            <div className="logo-item">
              <div className="logo-placeholder">FinanceCore</div>
            </div>
            <div className="logo-item">
              <div className="logo-placeholder">ManufacturingPlus</div>
            </div>
            <div className="logo-item">
              <div className="logo-placeholder">RetailTech</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
